document.addEventListener("DOMContentLoaded", function() {

	// // DETECT TOUCH
	// var isTouchDevice = (('ontouchstart' in window)
	//          || (navigator.MaxTouchPoints > 0)
	//          || (navigator.msMaxTouchPoints > 0));
	// if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
	// || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
	// isTouchDevice = true;
	// } else {
	// isTouchDevice = false;
	// }

	// let temp_token = ;
	
	if(localStorage.getItem('folksToken')) {
		getPosts();
	} else {
		getNewToken(getPosts);
	}

	let form = qs('.career-form form'),
		formData,
		trigger = qsa('.career-posts__select:not(.static)'),
		advisorCard = qs('.advisor-job'),
		stylistCard = qs('.stylist-job'),
		warehouseCard = qs('.warehouse-job'),
		hqPage = qs('.headquarters-jobs'),
		hqCard = qs('.headquarters-job'),
		careersPage = qs('.career-posts');
	
	if(form) {
		form.onsubmit = (e) => {
			e.preventDefault();
			formData = new FormData(form);

			if (formData.get('cv').size == 0) {
				formData.delete('cv');
			}

			if (formData.get('cell_phone_number').length == 0) {
				formData.delete('cell_phone_number')
			}

			console.log(formData);
			
			createCand();
		}

        qs('[name="cell_phone_number"]').onkeypress = (evt) => {
			var ASCIICode = (evt.which) ? evt.which : evt.keyCode;
			
	        if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) {
                return false;
            }
	        return true;
		}

        qs('[name="cv"]').onchange = (e) => {
            qs('.file-input span').innerHTML = e.target.files[0].name;
            qs('.file-input span').style.color = '#000';
        }
	}
	trigger.forEach(el => {
		el.onclick = (e) => {
			e.preventDefault();
			if(el.classList.contains('open')) {
				el.classList.remove('open');
			} else {
				el.classList.add('open');
			}
		};
	})

	if(careersPage) {
		qsa('[job-apply]').forEach(el => {
			el.onclick = () => {	
				qs('.career-form').classList.add('active');
				qs('[form-title]').innerHTML = el.dataset.title + ' (' + (el.dataset.loc == 'Éléganza' ? 'Québec' : el.dataset.loc) + ')';
				qs('#job_offer_id').value = el.dataset.id;

				let scrollToY = offsetTop(qs('.career-form'));
			
				scrollTo(scrollToY);
			}
		})
	}

	function renderJobs(data) {
		if(Shopify.locale == 'en') {
			var advisor = mapJobs(data, '1971'),
				warehouse = mapJobs(data, '1972'),
				stylist = mapJobs(data, '1974');
				hq = mapJobs(data, '1973');
		} else {
			var advisor = mapJobs(data, '1975'),
				warehouse = mapJobs(data, '1976'),
				stylist = mapJobs(data, '1977'),
				hq = mapJobs(data, '1978');
		}
		

		console.log('advisor');
		console.log(advisor);
		console.log('stylist');
		console.log(stylist);
		console.log('warehouse');
		console.log(warehouse);
		console.log('headquarters');
		console.log(hq);

		if(careersPage) {
			qs('.other-amount').innerHTML = `(${hq.length})`;
		}
		if(advisorCard) {
			initSelect(advisor, advisorCard);
			jobData(advisor[0], advisorCard);
		}
		if(stylistCard) {
			initSelect(stylist, stylistCard);
			jobData(stylist[0], stylistCard);
		}
		if(warehouseCard) {
			jobData(warehouse[0], warehouseCard);
		}
		if(hqCard) {
			let currentHq = hq.filter(el => window.location.pathname.includes(el.id));
			console.log('currentHq');
			console.log(currentHq);

			jobData(currentHq[0], hqCard);
		}

		if(hqPage) {
			let hqJobs = qs('.office-roles ul'),
				hqTemplate = qs('.office-roles li');
				
			if(hq.length > 0) {
				hq.forEach(el => {
					if(el.id == '32677') {
						jobData(el);
					} else {
						let newJob = hqTemplate.cloneNode(true);

						qs('a', newJob).setAttribute('href', Shopify.routes.root + `pages/${el.id}`);
						qs('h4', newJob).innerHTML = el.title;
						hqJobs.append(newJob);
					}
				})
			} else {
				qs('.office-roles__empty').style.display = 'block';
			}
		}
	}

	function mapJobs (data, cat_id) {
		return data.filter(job => job.categories.some(cat => cat.ca_id == cat_id))
			.map((job, ind) => {
				return {
					'loc': job.facility_name,
					'id': job.id,
					'benefits': job.benefits,
					'desc': job.description,
					'title': job.title
				}
			});
	}

	function initSelect (jobs, card) {
		let loc_list = qs('[loc-list]', card),
			loc_list_html = '';

		jobs.forEach(job => {
			loc_list_html += `<li data-title="${job.title}" data-value="${job.loc}">${job.loc}</li>`;
		});
		loc_list.innerHTML = loc_list_html;

		qsa('li', loc_list).forEach((li, ind) => {
			li.onclick = () => {
				jobData(jobs[ind], card);

				li.parentElement.children.forEach(el => el.classList.remove('active'));
				li.classList.add('active');
			}
		})
	}

	function jobData (cur, card) {	
		let benefitsHTML = '';
		// qs('[job-title]', card).innerHTML = cur.title;
		// qs('[job-desc]', card).innerHTML = cur.desc;
		if(qs('[loc-active]', card)) {
			qs('[loc-active]', card).innerHTML = cur.loc;
		}
		

		if(careersPage) {
			qs('[job-apply]', card).dataset.id = cur.id;
			qs('[job-apply]', card).dataset.title = cur.title;
			qs('[job-apply]', card).dataset.loc = cur.loc;

            cur.benefits.forEach(b => {
    			benefitsHTML += `<li>${b.cb_name}</li>`
    		})
    		qs('[job-benefits]', card).innerHTML = benefitsHTML;
		} else {
			let loc = cur.loc == 'Éléganza' ? 'Québec' : cur.loc;
			qs('[form-title]').innerHTML = cur.title + ` (${loc})`;

			if(qs('[job-loc]')) {
				qs('[job-loc]').innerHTML = loc;
			}
			
			qs('#job_offer_id').value = cur.id;

			if(qs('[job-desc]')) {
				qs('[job-desc]').innerHTML = cur.desc;
			}
			qsa('[dynamic-title]').forEach(el => el.innerHTML = cur.title);
		}
	}


	function getPosts () {
		fetch(`https://mwsserver.com/cvirtuose/Api/V1/JobOffer/list/${Shopify.locale}`, {
		method: 'GET',
		headers: {
			'Token': localStorage.getItem('folksToken')
		}
		})
		.then((response) => response.json())
		.then((data) => {
			if(!data.success) {
				getNewToken(getPosts);
			} else {
				console.log(data);
				renderJobs(data.jobs);
			}
		})
	}

	function createCand() {
		fetch('https://mwsserver.com/cvirtuose/Api/V1/Candidate', {
		method: 'POST',
		headers: {
			'Token': localStorage.getItem('folksToken')
		},
		body: formData
		})
		.then((response) => response.json())
		.then((data) => {
			console.log(data);
			
			if(data.success) {
				alert('Éléganza vous remercie pour votre intérêt envers ce poste ! Votre candidature a été crée. / Éléganza thanks you for your interest ! Your application has been sent.');
			} else {
                alert(`${data.error}. ${data.errorDescription}`);
              // getNewToken(createCand);
			}
		})
	}

   const headers = {
      "Content-Type": "application/json"
    };

	function getNewToken (callback) {
		fetch('https://script.google.com/macros/s/AKfycbywbrWtn-jEPZf2Eo9sdZczwBjtS_5rhzmyJmjwmnkyy4H5zTiSwIyFi695bWqGJfmFNw/exec')
		.then((response) => response.json())
		.then((data) => {
			localStorage.setItem('folksToken', data.token);
			if(callback) callback();
		});
	}
	
	const scrollRaf = window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame;
	
	function scrollTo(to) {
		const start = window.scrollY || window.pageYOffset;
		const time = Date.now();
		const duration = Math.abs(start - to) / 2;
	
		(function step() {
		var dx = Math.min(1, (Date.now() - time) / duration)
		var pos = start + (to - start) * easeInOutCubic(dx)
	
		window.scrollTo(0, pos)
	
		if (dx < 1) {
			scrollRaf(step);
		}
		})()
	}
	function easeInOutCubic(x) {
		return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
	}
	function offsetTop(el) {
		var rect = el.getBoundingClientRect(),
			scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		return rect.top + scrollTop;
	}
	
	function qs (selector, searchIn) {
		return searchIn ? searchIn.querySelector(selector) : document.querySelector(selector)
	}
	function qsa (selector, searchIn) {
		return searchIn ? searchIn.querySelectorAll(selector) : document.querySelectorAll(selector)
	}
});